(function () {
    var menu,
        menuContainer;
    var menuResize = function () {
        menuContainer.css('height', ($(window).outerHeight() - 60) + 'px');
    };

    $(window).on('load', function () {
        menu = $('#mobile-menu');
        menuContainer = menu.find('#mobile-menu-container');

        menuResize();

        menu.on('click', function () {
            menu.toggleClass('active');
        });

        menuContainer.on('click', function (event) {
            event.stopPropagation();
        });

        $('.menu-element:not(.menu-element-back)').on('click', function (event) {
            $(this).toggleClass('active').siblings().removeClass('active');
            event.stopPropagation();
        });

        $('.menu-element-language-' + menu.data('language')).addClass('active');

        $(window).on('scroll', function () {
            menu.removeClass('active');
        });
    }).on('resize', menuResize);
})();